export default __webpack_public_path__ + "static/medgas_valve_box_b.1d190f97044265c7b5f0ce18d9c1e813.png";